import useAuthContext from 'app/hooks/useAuthContext';
import useGroups from 'app/hooks/useGroups';

function useIsPotManager(enabled = true) {
  const { company, user } = useAuthContext();
  const query = useGroups.useFetchPotManagers(
    company?.id,
    { individualId: user?.id, page: 0, size: 1 },
    enabled && !!company?.id && !!user?.id
  );

  return {
    ...query,
    isPotManager: (query.data?.total ?? 0) > 0,
  };
}

export default useIsPotManager;
